import React from "react"
import PropTypes from "prop-types"
import WrapperSkeleton from "components/WrapperSkeleton"
import DefaultContainer from "shared/components/DefaultContainer"
import FloatLabelSelect from "shared/components/FloatLabelSelect"
import Typograph from "components/Typograph"

import styles from "./styles.css"

const Manager = ({ t, remainingHours, getOptions, changeDDG, loading }) => {
  return (
    <WrapperSkeleton
      path="managerOnlineInterface"
      isChildrenReady={!loading && remainingHours}
    >
      <DefaultContainer
        customClass={`Grid-cell u-flex u-flexRow ${styles.ddgNumber}`}
      >
        <div className={`u-flex u-flexCol ${styles.selectNumber}`}>
          <Typograph
            htmlTag="h2"
            weight="bold"
            size="medium"
            color="outer_space"
          >
            {t("NUMBER_DDG")}
          </Typograph>
          <FloatLabelSelect
            options={getOptions()}
            id="ddg"
            onChange={changeDDG}
          />
        </div>
        <div className={styles.hoursBalance}>
          <Typograph
            htmlTag="p"
            size="medium"
            weight="bold"
            color="outer_space"
          >
            {t("BALANCE")}:
          </Typograph>
          <div className={`u-flex ${styles.details}`}>
            <Typograph
              htmlTag="span"
              size="large"
              weight="bold"
              color="deep_sea_green"
            >
              {remainingHours}
            </Typograph>
            <Typograph
              htmlTag="p"
              size="large"
              weight="bold"
              color="outer_space"
            >
              &nbsp;{t("HOURS")}
            </Typograph>
          </div>
        </div>
      </DefaultContainer>
    </WrapperSkeleton>
  )
}

Manager.propTypes = {
  t: PropTypes.func.isRequired,
  remainingHours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  getOptions: PropTypes.func,
  changeDDG: PropTypes.func,
  loading: PropTypes.bool
}

export default Manager



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/Manager/index.js